@import '../../../../constants/screen-width-breakpoints.module.less';
@import '../input-constants.module.less';

.wrapper {
  position: relative;
  user-select: none;
}

.mask {
  .input-width();
  color: var(--grey-300);
  cursor: text;
  position: absolute;
  transition: all 300ms ease;
  top: 27px;
  left: 11px;
  user-select: none;
  pointer-events: none;
}

.without-label {
  top: 6px;
}

.mask-filled {
  color: transparent;
  opacity: 0;
  visibility: hidden;
}
